export default __webpack_public_path__ + "static/media/3rdPartyIcon.129768cd.svg";